




























































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { VueEditor } from "vue2-editor";
import {
  ScheduleType,
  ScheduleSession,
  ScheduleStatus,
  ScheduleLogType,
} from "@/store/modules/enums";
import { formatPhone, fileExt, fileIsImage, fileSize, fileIcon } from "@/utils";
import Header from "@/components/Header.vue";
import { ScheduleLogEntry } from "@/store/modules/types";

@Component({
  components: {
    VueEditor,
    Header,
  },
  filters: {
    phone: formatPhone,
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
})
export default class Appt extends Vue {
  @Prop(Number) readonly id!: number;
  appt: any | null = null;
  files = Array<any>();
  comment = "";
  quill = {
    toolbar: [
      ["bold", "italic", "underline"],
      [{ list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ color: [] }, { background: [] }],
    ],
  };
  async getAppt() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      this.appt = await this.$store.dispatch("schedule/getApptRecord", this.id);
      if (this.appt.serviceAddress) {
        this.appt.serviceAddress = JSON.parse(this.appt.serviceAddress);
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async getFiles() {
    try {
      this.files = await this.$store.dispatch(
        "schedule/getApptFileList",
        this.id
      );
    } catch (error) {
      console.log(error);
    }
  }
  async saveStatus(statusId: ScheduleStatus) {
    let title;
    switch (statusId) {
      case ScheduleStatus.ACCEPTED_BY_DRIVER:
        title = "ACCEPT DELIVERY";
        break;
      case ScheduleStatus.REJECTED_BY_DRIVER:
        title = "REJECT DELIVERY";
        break;
      case ScheduleStatus.OUT_FOR_DELIVERY:
        title = "NOTIFY NEXT DELIVERY";
        break;
      case ScheduleStatus.DELIVERED:
        title = "REPORT DELIVERY";
        break;
      case ScheduleStatus.UNDELIVERED:
        title = "REPORT FAILED DELIVERY";
        break;
    }
    this.$modal.show("dialog", {
      title,
      text: "Are you sure?",
      buttons: [
        {
          title: "Yes",
          handler: async () => {
            this.$store.commit("main/SET_LOADING", true);
            try {
              const { id } = this.appt;
              await this.$store.dispatch("schedule/saveApptStatus", {
                id,
                statusId,
              });
              this.$modal.hide("dialog");
              this.getAppt();
            } catch (error) {
              console.log(error);
            } finally {
              this.$store.commit("main/SET_LOADING", false);
            }
          },
        },
        {
          title: "No",
          default: true,
        },
      ],
    });
  }
  async saveComment(comment: string) {
    if (comment) this.comment = comment;
    if (!this.comment) return;
    let logTypeId = ScheduleLogType.OFFICE_COMMENT;
    if (this.isDeliveryAppt) {
      logTypeId = ScheduleLogType.DRIVER_COMMENT;
    }
    const entry: ScheduleLogEntry = {
      apptId: this.appt.id,
      typeId: logTypeId,
      comment: this.comment,
    };
    this.$store.commit("main/SET_LOADING", true);
    try {
      await this.$store.dispatch("schedule/saveApptLog", entry);
      this.comment = "";
      this.$bvToast.toast("Your note has been received!", {
        title: "WaitingMed",
        toaster: "b-toaster-top-center",
        autoHideDelay: 2000,
        solid: true,
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async fileDownload(file) {
    this.$store.commit("main/SET_LOADING", true);
    try {
      await this.$store.dispatch("schedule/downloadFile", file.key);
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  apptTypeIcon(typeId) {
    switch (typeId) {
      case ScheduleType.REGULAR:
        return "far fa-calendar-alt";
      case ScheduleType.SERVICE:
        return "fas fa-stethoscope";
      case ScheduleType.DELIVERY:
        return "fas fa-truck";
      case ScheduleType.READY_RESPONDERS:
        return "fas fa-user-md";
    }
  }
  apptTypeName(typeId) {
    switch (typeId) {
      case ScheduleType.REGULAR:
        return "Appointment";
      case ScheduleType.SERVICE:
        return "Service";
      case ScheduleType.DELIVERY:
        return "Delivery";
      case ScheduleType.READY_RESPONDERS:
        return "Ready Responder";
    }
  }
  get isServiceAppt() {
    if (!this.appt) return false;
    return this.appt.typeId === ScheduleType.SERVICE;
  }
  get isDeliveryAppt() {
    if (!this.appt) return false;
    return this.appt.typeId === ScheduleType.DELIVERY;
  }
  get fileIcon() {
    return fileIcon;
  }
  get fileSize() {
    return fileSize;
  }
  get seviceFullAddress() {
    if (this.appt && this.appt.serviceAddress) {
      const { serviceAddress } = this.appt;
      let address = "";
      address += serviceAddress.line1 ? serviceAddress.line1 : "";
      address += " " + serviceAddress.line2 ? serviceAddress.line2 : "";
      address += " " + serviceAddress.city ? serviceAddress.city : "";
      address += " " + serviceAddress.state ? serviceAddress.state : "";
      address += " " + serviceAddress.zip ? serviceAddress.zip : "";
      return address;
    }
    return "";
  }
  get ScheduleStatus() {
    return ScheduleStatus;
  }
  mounted() {
    this.getAppt();
    this.getFiles();
  }
}
